const STORAGE_KEY = 'avanti-tab-id'

let cached = null

/**
 * Generate an id that only has to be unique among the tabs a single user has open.
 */
const generate = () => {
  const crypto = window.crypto || window.msCrypto

  if (crypto && crypto.getRandomValues) {
    const buffer = new Uint32Array(2)

    crypto.getRandomValues(buffer)

    return buffer[0].toString(36) + buffer[1].toString(36)
  }

  return Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10)
}

/**
 * Id identifying this browser tab.
 *
 * Kept in sessionStorage so it is unique per tab but survives reloads and,
 * more importantly, WebSocket reconnects. The presence lock on an objekt is
 * tied to this id, so anything that changes it hands the lock to someone else.
 */
export default () => {
  if (cached) {
    return cached
  }

  // Private mode and friends can make sessionStorage throw on access.
  try {
    cached = window.sessionStorage.getItem(STORAGE_KEY)

    if (!cached) {
      cached = generate()
      window.sessionStorage.setItem(STORAGE_KEY, cached)
    }
  } catch (error) {
    cached = generate()
  }

  return cached
}



// WEBPACK FOOTER //
// ./src/plugins/tab-id.js